export default "__VITE_ASSET__BH7x9o4X__"